import { render, staticRenderFns } from "./SectionPicker.vue?vue&type=template&id=886eb582&"
import script from "./SectionPicker.vue?vue&type=script&lang=js&"
export * from "./SectionPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('886eb582')) {
      api.createRecord('886eb582', component.options)
    } else {
      api.reload('886eb582', component.options)
    }
    module.hot.accept("./SectionPicker.vue?vue&type=template&id=886eb582&", function () {
      api.rerender('886eb582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/FormBuilder/SectionPicker.vue"
export default component.exports